import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback,
  useContext,
} from "react";
import { AuthContext } from "../../context/AuthContext";
import Grid from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import { Box, TextField, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableContainer } from "@mui/material";
import Button from "@mui/material/Button";
import { useSnackbar } from "notistack";
import PulseLoader from "react-spinners/PulseLoader";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { getDataWithToken } from "../../services/GetDataService";

import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import EmailIcon from "@mui/icons-material/Email";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { days, designationList, roleList } from "../../data";
import { handlePostData } from "../../services/PostDataService";
import { handlePutData } from "../../services/PutDataService";
import ImageUpload from "../../utils/ImageUpload";
import TextEditor from "../../utils/TextEditor";

const branchServiceObject = {
  order_no: "",
  name: "",
};

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "16px 24px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#EAECF0",
  borderStyle: "dashed",
  backgroundColor: "#fff",
  // color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
  borderRadius: "12px",
};

const focusedStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};
const form = {
  padding: "50px",
  background: "#fff",
  borderRadius: "10px",
  width: "400px",
  boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
};
const UpdateBranch = ({ clearFilter, row }) => {
  const navigate = useNavigate();
  const { login, ifixit_admin_panel, logout } = useContext(AuthContext);
  const [updateDialog, setUpdateDialog] = useState(false);
  const [name, setName] = useState("");
  const [parent_id, setParent_id] = useState("");
  const [status, setStatus] = useState("");
  const [branchList, setBranchList] = useState([]);
  const [loading2, setLoading2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const { enqueueSnackbar } = useSnackbar();

  const [mapUrl, setMapUrl] = useState("");
  const [endpoint, setEndpoint] = useState("");
  const [opening_hours, setOpening_hours] = useState("");
  const [description, setDescription] = useState("");
  const [number, setNumber] = useState("");
  const [orderNo, setOrderNo] = useState("");
  const [offDay, setOffDay] = useState("");
  const [address, setAddress] = useState();
  const [file, setFile] = useState(null);
  const [branchServicesList, setBranchServicesList] = useState([]);

  const handleDialogClose = (event, reason) => {
    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
      setUpdateDialog(false);
    }
  };

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const clearForm = () => {
    setName("");
    setParent_id("");
    setAddress("");
    setNumber("");
    setFile(null);
    setOrderNo("");
    setOffDay("");
    setMapUrl("");
    setEndpoint("");
    setOpening_hours("");
    setDescription("");
    setBranchServicesList([]);
    setStatus("");
  };
  const onSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    // var formdata = new FormData();
    // formdata.append("name", name);

    // formdata.append("parent_id", parent_id);

    // let data = {
    //   name: name.trim(),

    //   parent_name: parent_id.trim(),
    //   status: status,
    // };

    var formdata = new FormData();
    formdata.append("name", name);
    formdata.append("phone_no_1", number);
    formdata.append("address", address);
    formdata.append("off_day", offDay);
    formdata.append("order_no", orderNo);
    formdata.append("map_url", mapUrl);
    formdata.append("endpoint", endpoint);
    formdata.append("opening_hours", opening_hours);
    formdata.append("description", description);
    formdata.append(
      "branch_services",
      JSON.stringify(
        branchServicesList
          .filter((s) => s.name?.trim())
          .map((s) => ({
            order_no: Number(s.order_no) || 0,
            name: s.name?.trim(),
          })),
      ),
    );
    formdata.append("status", status);

    if (file) {
      formdata.append("image", file);
    }

    let response = await handlePutData(
      `/api/v1/branch/update/${row?._id}`,
      formdata,
      true,
    );

    console.log("response", response);
    if (response?.status === 401) {
      logout();
      return;
    }
    if (response.status >= 200 && response.status < 300) {
      handleSnakbarOpen("Updated successfully", "success");
      clearFilter(); // this is for get the table list again
      clearForm();
      handleDialogClose();
    } else {
      setLoading(false);
      handleSnakbarOpen(response?.data?.message, "error");
    }

    setLoading(false);
    // }
  };

  const customeTextFeild = {
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
    // padding: "15px 20px",

    // "& label.Mui-focused": {
    //   color: "#A0AAB4",
    // },

    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {
      // padding: "15px 24px 15px 0px",
    },
    "& .MuiOutlinedInput-root": {
      // paddingLeft: "24px",
      "& fieldset": {
        borderColor: "",
      },

      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };

  const customeSelectFeild = {
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
    background: "#ffffff",

    "& label.Mui-focused": {
      color: "#E5E5E5",
    },

    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {
      // padding: "10px 16px",
    },
    "& .MuiOutlinedInput-root": {
      // paddingLeft: "24px",
      "& fieldset": {
        borderColor: "#",
      },

      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };

  const getDropdownList = async () => {
    setLoading2(true);

    let url = `/api/v1/branch/dropdownlist`;
    let allData = await getDataWithToken(url);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setBranchList(allData?.data?.data);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setLoading2(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading2(false);
  };
  useEffect(() => {
    console.log("useEffect===========================", row);

    setName(row?.name);
    setNumber(row?.phone_no_1);
    setOrderNo(row?.order_no);
    setOffDay(row?.off_day);
    setMapUrl(row?.map_url);
    setEndpoint(row?.endpoint);
    setOpening_hours(row?.opening_hours || "");
    setDescription(row?.description || "");
    let branchServices = row?.branch_services;
    if (typeof branchServices === "string") {
      try {
        branchServices = JSON.parse(branchServices);
      } catch {
        branchServices = [];
      }
    }
    setBranchServicesList(
      Array.isArray(branchServices) && branchServices.length > 0
        ? branchServices.map((s) => ({
            order_no: s?.order_no ?? "",
            name: s?.name ?? "",
          }))
        : [],
    );
    setAddress(row?.address);
    setStatus(row?.status);
  }, [updateDialog]);
  return (
    <>
      {/* <Button
        variant="contained"
        disableElevation
        sx={{ py: 1.125, px: 2, borderRadius: "6px" }}
        onClick={() => setUpdateDialog(true)}
        startIcon={
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.99996 4.16675V15.8334M4.16663 10.0001H15.8333"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        }
      >
        Update Branch
      </Button> */}

      <IconButton
        variant="contained"
        // color="success"
        disableElevation
        onClick={() => {
          setUpdateDialog(true);
          // getDropdownList();
        }}
      >
        {/* <EditOutlinedIcon /> */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="Outline"
          viewBox="0 0 24 24"
          width="18"
          height="18"
        >
          <path
            d="M18.656.93,6.464,13.122A4.966,4.966,0,0,0,5,16.657V18a1,1,0,0,0,1,1H7.343a4.966,4.966,0,0,0,3.535-1.464L23.07,5.344a3.125,3.125,0,0,0,0-4.414A3.194,3.194,0,0,0,18.656.93Zm3,3L9.464,16.122A3.02,3.02,0,0,1,7.343,17H7v-.343a3.02,3.02,0,0,1,.878-2.121L20.07,2.344a1.148,1.148,0,0,1,1.586,0A1.123,1.123,0,0,1,21.656,3.93Z"
            fill="#787878"
          />
          <path
            d="M23,8.979a1,1,0,0,0-1,1V15H18a3,3,0,0,0-3,3v4H5a3,3,0,0,1-3-3V5A3,3,0,0,1,5,2h9.042a1,1,0,0,0,0-2H5A5.006,5.006,0,0,0,0,5V19a5.006,5.006,0,0,0,5,5H16.343a4.968,4.968,0,0,0,3.536-1.464l2.656-2.658A4.968,4.968,0,0,0,24,16.343V9.979A1,1,0,0,0,23,8.979ZM18.465,21.122a2.975,2.975,0,0,1-1.465.8V18a1,1,0,0,1,1-1h3.925a3.016,3.016,0,0,1-.8,1.464Z"
            fill="#787878"
          />
        </svg>
      </IconButton>

      <Dialog
        open={updateDialog}
        onClose={handleDialogClose}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px", // Customize the border-radius here
          },
        }}
        PaperProps={{
          component: "form",
          onSubmit: onSubmit,
        }}
        maxWidth="lg"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            fontSize: "20px",
            fontFamily: '"Inter", sans-serif',
            fontWeight: 600,
            color: "#0F1624",
            position: "relative",
            px: 2,
            borderBottom: "1px solid #EAECF1",
          }}
        >
          Update Branch
          <IconButton
            sx={{ position: "absolute", right: 0, top: 0 }}
            onClick={() => setUpdateDialog(false)}
          >
            <svg
              width="46"
              height="44"
              viewBox="0 0 46 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29 16L17 28M17 16L29 28"
                stroke="#656E81"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            maxWidth: "800px",
            minWidth: "800px",
            px: 2,
            borderBottom: "1px solid #EAECF1",
            my: 1,
          }}
        >
          <Grid container spacing={2}>
            <Grid size={6}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                Branch Name
              </Typography>
              <TextField
                required
                size="small"
                fullWidth
                id="name"
                placeholder="Full Name"
                variant="outlined"
                sx={{ ...customeTextFeild }}
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </Grid>
            {/* <Grid size={6}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                Parent Branch
              </Typography>

              <FormControl
                fullWidth
                size="small"
                sx={{
                  ...customeSelectFeild,
                  "& label.Mui-focused": {
                    color: "rgba(0,0,0,0)",
                  },

                  "& .MuiOutlinedInput-input img": {
                    position: "relative",
                    top: "2px",
                  },
                }}
              >
                {parent_id?.length < 1 && (
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{ color: "#b3b3b3", fontWeight: 300 }}
                  >
                    Select Branch
                  </InputLabel>
                )}
                <Select
                  required
                  labelId="demo-simple-select-label"
                  id="baseLanguage"
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 250, // Set the max height here
                      },
                    },
                  }}
                  value={parent_id}
                  onChange={(e) => setParent_id(e.target.value)}
                >
                  {branchList?.map((item) => (
                    <MenuItem key={item} value={item?.name}>
                      {item?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid> */}
            <Grid size={6}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                Mobile No
              </Typography>
              <TextField
                required
                size="small"
                fullWidth
                id="number"
                type="number"
                onWheel={(e) => e.target.blur()}
                placeholder="Full Number"
                variant="outlined"
                sx={{ ...customeTextFeild }}
                value={number}
                onChange={(e) => {
                  if (
                    e.target.value.length <= 11 &&
                    /^\d*$/.test(e.target.value)
                  ) {
                    setNumber(e.target.value);
                  }
                }}
              />
            </Grid>
            <Grid size={6}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                Order No
              </Typography>
              <TextField
                required
                size="small"
                fullWidth
                id="orderNo"
                type="number"
                placeholder="Order No"
                variant="outlined"
                sx={{ ...customeTextFeild }}
                value={orderNo}
                onChange={(e) => {
                  setOrderNo(e.target.value);
                }}
              />
            </Grid>
            <Grid size={6}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                Off Day
              </Typography>
              <TextField
                size="small"
                fullWidth
                id="offDay"
                placeholder="Full Off Day"
                variant="outlined"
                sx={{ ...customeTextFeild }}
                value={offDay}
                onChange={(e) => {
                  setOffDay(e.target.value);
                }}
              />
              {/* <FormControl
                fullWidth
                size="small"
                sx={{
                  ...customeSelectFeild,
                  "& label.Mui-focused": {
                    color: "rgba(0,0,0,0)",
                  },

                  "& .MuiOutlinedInput-input img": {
                    position: "relative",
                    top: "2px",
                  },
                }}
              >
                {offDay?.length < 1 && (
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{ color: "#b3b3b3", fontWeight: 300 }}
                  >
                    Select Branch
                  </InputLabel>
                )}
                <Select
                  required
                  labelId="demo-simple-select-label"
                  id="baseLanguage"
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 250, // Set the max height here
                      },
                    },
                  }}
                  value={offDay}
                  onChange={(e) => setOffDay(e.target.value)}
                >
                  {days?.map((item) => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
            </Grid>
            <Grid size={6}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                Address
              </Typography>
              <TextField
                required
                size="small"
                fullWidth
                id="address"
                placeholder="Full Address"
                variant="outlined"
                sx={{ ...customeTextFeild }}
                value={address}
                onChange={(e) => {
                  setAddress(e.target.value);
                }}
              />
            </Grid>

            <Grid size={6}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                Map URL
              </Typography>
              <TextField
                required
                size="small"
                fullWidth
                id="mapUrl"
                placeholder="Enter map url"
                variant="outlined"
                sx={{ ...customeTextFeild }}
                value={mapUrl}
                onChange={(e) => {
                  setMapUrl(e.target.value);
                }}
              />
            </Grid>
            <Grid size={6}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                URL Endpoint *{" "}
                <span style={{ color: "#898989" }}>
                  {" "}
                  (e.g: /contact-us/xxxx-xxxx-xxxx)
                </span>
              </Typography>
              <TextField
                size="small"
                fullWidth
                id="endpoint"
                placeholder="Enter endpoint"
                variant="outlined"
                sx={{ ...customeTextFeild }}
                value={endpoint}
                onChange={(e) => {
                  setEndpoint(e.target.value);
                }}
              />
            </Grid>
            <Grid size={12}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                Opening Hours
              </Typography>
              <TextEditor
                convertedContent={opening_hours}
                setConvertedContent={setOpening_hours}
                data={opening_hours}
              />
            </Grid>
            <Grid size={6}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                Select Status
              </Typography>
              <FormControl
                fullWidth
                size="small"
                sx={{
                  ...customeSelectFeild,
                  "& label.Mui-focused": {
                    color: "rgba(0,0,0,0)",
                  },

                  "& .MuiOutlinedInput-input img": {
                    position: "relative",
                    top: "2px",
                  },
                }}
              >
                {/* {parent_id?.length < 1 && (
              <InputLabel
                id="demo-simple-select-label"
                sx={{ color: "#b3b3b3", fontWeight: 300 }}
              >
                Select Status
              </InputLabel>
            )} */}
                <Select
                  // required
                  labelId="demo-simple-select-label"
                  id="baseLanguage"
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 250, // Set the max height here
                      },
                    },
                  }}
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <MenuItem value={true}>Active</MenuItem>
                  <MenuItem value={false}>Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid size={12}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                Description
              </Typography>
              <TextEditor
                convertedContent={description}
                setConvertedContent={setDescription}
                data={description}
              />
            </Grid>
            <Grid size={12}>
              <div
                style={{
                  background: "#fff",
                  border: "1px solid #EAECF1",
                  borderRadius: "12px",
                  overflow: "hidden",
                  padding: "16px 0",
                  boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
                }}
              >
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ px: 1.5, mb: 1.75 }}
                >
                  <Grid size={{ xs: 6 }}>
                    <Typography
                      variant="h6"
                      gutterBottom
                      component="div"
                      sx={{ color: "#0F1624", fontWeight: 600, margin: 0 }}
                    >
                      Branch Services
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 6 }} sx={{ textAlign: "right" }}>
                    <Button
                      color="text"
                      size="small"
                      sx={{ border: "1px solid #F2F3F7", px: 2 }}
                      startIcon={
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 4.16699V15.8337M4.16669 10.0003H15.8334"
                            stroke="black"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      }
                      onClick={() =>
                        setBranchServicesList([
                          ...branchServicesList,
                          { ...branchServiceObject },
                        ])
                      }
                    >
                      Add Service
                    </Button>
                  </Grid>
                </Grid>

                <TableContainer>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ whiteSpace: "nowrap" }}>
                          Order No
                        </TableCell>
                        <TableCell style={{ whiteSpace: "nowrap" }}>
                          Service Name
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          Actions
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {branchServicesList?.length > 0 ? (
                        branchServicesList?.map((item, i) => (
                          <TableRow
                            key={i}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            <TableCell sx={{ minWidth: "130px" }}>
                              <TextField
                                size="small"
                                type="number"
                                id="order_no"
                                placeholder="Order No"
                                variant="outlined"
                                sx={{
                                  ...customeTextFeild,
                                  "& .MuiOutlinedInput-input": {
                                    padding: "6.5px 12px",
                                    fontSize: "14px",
                                  },
                                  minWidth: "120px",
                                }}
                                value={item.order_no ?? ""}
                                onChange={(e) => {
                                  const updatedValue = e.target.value;
                                  setBranchServicesList((prev) =>
                                    prev.map((obj, index) =>
                                      index === i
                                        ? { ...obj, order_no: updatedValue }
                                        : obj,
                                    ),
                                  );
                                }}
                                onWheel={(e) => e.target.blur()}
                              />
                            </TableCell>
                            <TableCell sx={{ minWidth: "200px" }}>
                              <TextField
                                size="small"
                                id="name"
                                placeholder="Service Name"
                                variant="outlined"
                                sx={{
                                  ...customeTextFeild,
                                  "& .MuiOutlinedInput-input": {
                                    padding: "6.5px 12px",
                                    fontSize: "14px",
                                  },
                                  minWidth: "200px",
                                }}
                                value={item.name ?? ""}
                                onChange={(e) => {
                                  const updatedValue = e.target.value;
                                  setBranchServicesList((prev) =>
                                    prev.map((obj, index) =>
                                      index === i
                                        ? { ...obj, name: updatedValue }
                                        : obj,
                                    ),
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell
                              sx={{ minWidth: "80px", textAlign: "right" }}
                            >
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setBranchServicesList((prev) =>
                                    prev.filter((_, index) => index !== i),
                                  );
                                }}
                              >
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M12.2836 7.5L11.9951 15M8.00475 15L7.71629 7.5M16.023 4.82547C16.308 4.86851 16.592 4.91456 16.8749 4.96358M16.023 4.82547L15.1331 16.3938C15.058 17.3707 14.2434 18.125 13.2636 18.125H6.73625C5.75649 18.125 4.94191 17.3707 4.86677 16.3938L3.9769 4.82547M16.023 4.82547C15.0676 4.6812 14.1012 4.57071 13.1249 4.49527M3.12494 4.96358C3.40792 4.91456 3.69192 4.86851 3.9769 4.82547M3.9769 4.82547C4.93225 4.6812 5.89868 4.57071 6.87494 4.49527M13.1249 4.49527V3.73182C13.1249 2.74902 12.3661 1.92853 11.3838 1.8971C10.9243 1.8824 10.463 1.875 9.99994 1.875C9.5369 1.875 9.07559 1.8824 8.61612 1.8971C7.63382 1.92853 6.87494 2.74902 6.87494 3.73182V4.49527M13.1249 4.49527C12.0937 4.41558 11.0516 4.375 9.99994 4.375C8.9483 4.375 7.90614 4.41558 6.87494 4.49527"
                                    stroke="#4A5468"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow
                          sx={{
                            "&:last-child td, &:last-child th": {
                              border: 0,
                            },
                          }}
                        >
                          <TableCell colSpan={3} align="center">
                            No service added
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </Grid>

            <Grid size={12}>
              <Typography
                variant="medium"
                color="text.main"
                gutterBottom
                sx={{ fontWeight: 500 }}
              >
                Branch Image
              </Typography>
              <Box>
                <ImageUpload
                  file={file}
                  setFile={setFile}
                  dimension="Size: (200 : 100)"
                />
              </Box>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ px: 2 }}>
          <Button
            variant="outlined"
            onClick={handleDialogClose}
            sx={{
              px: 2,
              py: 1.25,
              fontSize: "14px",
              fontWeight: 600,
              color: "#344054",
              border: "1px solid #D0D5DD",
              boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
            }}
          >
            Close
          </Button>
          <Button
            variant="contained"
            disabled={loading}
            type="submit"
            sx={{
              px: 2,
              py: 1.25,
              fontSize: "14px",
              fontWeight: 600,
              minWidth: "127px",
              minHeight: "44px",
            }}
            // style={{ minWidth: "180px", minHeight: "35px" }}
            autoFocus
            disableElevation
          >
            <PulseLoader
              color={"#4B46E5"}
              loading={loading}
              size={10}
              speedMultiplier={0.5}
            />{" "}
            {loading === false && "Save changes"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UpdateBranch;
